import { render, staticRenderFns } from "./syncState.vue?vue&type=template&id=35d40926&scoped=true"
import script from "./syncState.vue?vue&type=script&lang=js"
export * from "./syncState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d40926",
  null
  
)

export default component.exports